import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { RowBadges } from "./RowTableBadges";
import { Box, TablePagination } from "@mui/material";
import ModalBadge from "../ModalBadge";
import ModalDetailsBadge from "../ModalDetailsBadge";
import ModalDeleteBadge from "../ModalDeleteBadge";

export default function TableBadges({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [showModalDetail, setShowModalDetail] = React.useState(false);
  const [showModalEdit, setShowModalEdit] = React.useState(false);
  const [selectedBadge, setSelectedBadge] = React.useState(null);
  const [showModalDeleteBadge, setShowModalDeleteBadge] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      <ModalBadge
        initialData={selectedBadge}
        isEdit={true}
        open={showModalEdit}
        setLoading={setLoading}
        setOpen={setShowModalEdit}
      />
      <ModalDetailsBadge
        open={showModalDetail}
        badgeData={selectedBadge}
        setOpen={setShowModalDetail}
      />
      <ModalDeleteBadge
        badgeData={selectedBadge}
        open={showModalDeleteBadge}
        setLoading={setLoading}
        setOpen={setShowModalDeleteBadge}
      />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Nombre del Logro</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                  <TableCell align="center">Membresía</TableCell>
                  <TableCell align="center">Estatus</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <RowBadges
                      key={row._id}
                      row={row}
                      setShowModalEdit={setShowModalEdit}
                      setSelectedBadge={setSelectedBadge}
                      setShowModalDetail={setShowModalDetail}
                      setShowModalDelete={setShowModalDeleteBadge}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
